/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { NavItem, NavItemModel } from "../NavItem";

export type BottomNavProps = {
  items: NavItemModel[];
  testId?: string;
};

export const BottomNav = ({ items, testId }: BottomNavProps) => (
  <nav
    aria-label="Bottom"
    data-testid={testId}
    className="fixed inset-x-0 bottom-0 z-1100 flex h-16 items-center bg-forest-green-950"
    style={{
      height: "calc(4rem + var(--app-safe-area-bottom))",
      paddingBottom: "var(--app-safe-area-bottom)",
    }}
  >
    <ul className="flex w-full items-center justify-between">
      {items.map((item) => (
        <NavItem key={item.id} size="sm" {...item} />
      ))}
    </ul>
  </nav>
);
